<template>
  <div class="foot-notice">
    <ul class="foot-notice__list">
      <li>・{{ menuTitle }}は、当日分と翌日分をご覧になることができ、ご購入日から1ヶ月間有効です。この商品は継続課金型商品になります。</li>
      <li>・「購入する」ボタンをタップすると、最初の月額料金の決済が行われ、それ以降は毎月同じ日に利用料の決済が行われます。決済日の日付がない場合（31日等）は、代わりにその月の最終日が決済日となります。</li>
      <li>・購入手続完了後、直ちに{{ menuTitle }}をご覧になれます。</li>
      <li>・購入後、マイページからいつでも解約することができます。解約にかかる手数料は一切ありません。なお、日割りによる清算はありません。月の途中で解約の申し込みを行った場合でも、当月の月額利用金が満額で発生します（次回更新日の前日まで、今日の運勢を利用いただけます）。</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    menuTitle: {
      type: String,
      require: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.foot-notice {
  background: #FDFAF9;
  border-radius: 7px;
  padding: 20px;
  margin: 30px 20px 40px;
  &__list {
    margin: 0;
    padding: 0;
    font-size: 12px;
    line-height: 18px;
    text-align: justify;
    > li {
      margin: 0 0 1.3em;
      padding: 0;
      list-style: none;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/partials/FootNotice.vue